import { AuthData, BannerSection } from "../../../types/types";
import { Currency, MarketTab } from "../types";

export const getBannerSectionByTab = (tab: MarketTab): BannerSection => {
  const map: Record<MarketTab, BannerSection> = {
    STOCKS:          "TRADE_STOCKS",
    CEDEARS:         "TRADE_CEDEARS",
    SOVEREIGN_BONDS: "TRADE_BONDS",
    TREASURY_NOTES:  "TRADE_BILLS",
    CORPORATE_BONDS: "TRADE_CORPORATES",
    REPO_OPERATION:  "TRADE_REPOS",
    OPTIONS:         "TRADE_OPTIONS",
    FUNDS:           "TRADE_FUNDS",
  };
  return map[tab] ?? "TRADE";
};

// TODO: Remove in favour of `asCurrency` on `src/utils/index.ts`
export const asMoney = (value?: number) =>
  value?.toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const labelsForCurrency: { [key in Currency]: string } = {
  ARS: "ARS",
  DOLLAR_CCL: "CCL",
  DOLLAR_MEP: "MEP",
};

export const getAuthToken = () => {
  const localAuth = localStorage.getItem("allaria-auth");
  const parsedLocalAuth: AuthData | null =
    (localAuth && JSON.parse(localAuth)) ?? null;

  return parsedLocalAuth?.access_token;
};

export const withSixDecimals = (value?: number) =>
  value?.toLocaleString("es-AR", {
    minimumFractionDigits: 6,
    maximumFractionDigits: 6,
  });
